import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AnonProtocolTable from "../ConfigurePages/AnonProtocolTable";
import DiffEditor from "../ConfigurePages/DiffEditor";
import FetchDataTable from "../ConfigurePages/FetchData";
import FilterTable from "../ConfigurePages/FilterTable";
import PacsTable from "../ConfigurePages/PacsTable";
import PlatformTable from "../ConfigurePages/PlatformTable";
import HL7Config from "../HL7Components/HL7Config";
import HL7Nodes from "../HL7Components/HL7Nodes";
import ConfigDataTable from "../Tables/ConfigDataTable";
import Widget from "../widget/Widget";
import WidgetPage from "../widget/WidgetPage";
import DnDFlow from "../WorkflowComponents/ReactRendererFlow";
import Configure from "./Configure";
import Home from "./Home";
import Login from "./Login";
import SignUp from "./SignUp";
import UpdatePassword from "./UpdatePassword";

const Main = () => {
  const isAuthenticated = localStorage.getItem("authenticated");
  console.log("isAuthenticated", isAuthenticated);

  const privateRoutes = (
    <Routes>
      <Route path="/configure" element={<Configure />} />
      <Route path="/SignUp" element={<SignUp />} />
      <Route path="/Pacsconfig" element={<ConfigDataTable />} />
      <Route path="/filterdata" element={<FilterTable />} />
      <Route path="/pacsdata" element={<PacsTable />} />
      <Route path="/flow/:routerID" element={<DnDFlow />} />
      <Route path="/fetchData" element={<FetchDataTable />} />
      <Route path="/platformdata" element={<PlatformTable />} />
      <Route path="/protocoldata" element={<AnonProtocolTable />} />
      <Route path="/diffchecker" element={<DiffEditor />} />
      <Route path="/home" element={<Home />} />
      <Route path="/Hl7Config" element={<HL7Config />} />
      <Route path="/Hl7Nodes" element={<HL7Nodes />} />
      <Route path="/update-password" element={<UpdatePassword />} />
    </Routes>
  );

  if (isAuthenticated) {
    return privateRoutes;
  } else {
    return <Navigate to="/login" />;
  }
};

const App = () => (
  <Routes>
    <Route path="/" element={<Login />} />
    <Route path="/login" element={<Login />} />
    {/* <Route path="/signup" element={<SignUp />} /> */}
    <Route path="/*" element={<Main />} />
    <Route path="/widget-page" element={<Widget />} />
    <Route path="/widget" element={<WidgetPage />} />
  </Routes>
);

export default App;
